import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes/router'

// Self-hosted brand fonts (loaded once, subset by weight for performance).
// Oswald = display/headings (industrial, condensed) · Manrope = body (premium, readable)
// · Space Grotesk = buttons/labels/eyebrows (technical B2B accent).
import '@fontsource/oswald/500.css'
import '@fontsource/oswald/600.css'
import '@fontsource/oswald/700.css'
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'
import '@fontsource/space-grotesk/500.css'
import '@fontsource/space-grotesk/600.css'
import '@fontsource/space-grotesk/700.css'

// Recover from stale-chunk requests after a new deploy: when a lazy import fails
// (its hashed file no longer exists on the server), reload once to fetch fresh assets.
// Guarded for the SSR prerender pass, and one-shot per session to avoid reload loops.
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', () => {
    if (!sessionStorage.getItem('tf-chunk-reload')) {
      sessionStorage.setItem('tf-chunk-reload', '1')
      window.location.reload()
    }
  })
}

export const createRoot = ViteReactSSG({ routes })
